import { useMemo } from 'react'
import { GridColumn } from '@glideapps/glide-data-grid'
import { EmployerMetaField } from 'Services/employerService'
import { GridColumnKind } from '../gridModel'

type KindedColumn = { column: GridColumn; kind: GridColumnKind }

const BASE_COLUMNS: KindedColumn[] = [
  { column: { id: 'email', title: 'Email', width: 200 }, kind: 'readonly' },
  { column: { id: 'first_name', title: 'First Name', width: 150 }, kind: 'userField' },
  { column: { id: 'last_name', title: 'Last Name', width: 150 }, kind: 'userField' }
]

export const useGridColumns = (metaFields: EmployerMetaField[]) => {
  const { columns, columnKinds } = useMemo(() => {
    const metaColumns: KindedColumn[] = metaFields.map((field) => {
      const title = field.required
        ? `${field.fieldName} *`
        : field.unique
        ? `${field.fieldName} (unique)`
        : field.fieldName

      return { column: { id: field.fieldName, title, width: 180 }, kind: 'metadata' }
    })

    const allColumns = [...BASE_COLUMNS, ...metaColumns]

    return {
      columns: allColumns.map(({ column }) => column),
      columnKinds: allColumns.map(({ kind }) => kind)
    }
  }, [metaFields])

  return { columns, columnKinds }
}
